export default __webpack_public_path__ + "static/media/thank-you.91d9d0f4.jpg";